import {ReactComponent as GithubIcon} from 'assets/img/github.svg';
import './styles.css'


function Navbar(){

    return(
    <header>
    <nav className="container">
        <div className="dsmovie-nav-content">
            <h1 className="moviestars-title">StarsMovies</h1>
            <a href="https://github.com/rubens-rangel/dsmovie" target="_blank" rel="noreferrer">
                <div className="dsmovie-contact-container">
                    <GithubIcon />
                    <p className="dsmovie-contact-link">/rubens-rangel</p>
                </div>
            </a>
        </div>
    </nav>
</header>
)
}
export default Navbar;
